import React, { useState } from 'react'
import { Box, makeStyles, createStyles, Typography } from '@material-ui/core'
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from 'gobalComponents/Accordion'

const DettailedInformation = ({ service }) => {
  const classes = useStyles()
  const [expanded, setExpanded] = useState('')


  const handleChange = (panel) => (event, newExpanded) => {
    console.log({panel, newExpanded})
    // setExpanded(newExpanded ? panel : false)
    if(newExpanded){
      setExpanded(oldState=>[...oldState, panel])
    }else{
      setExpanded(oldState=> oldState.filter(item=> item!== panel))
    }
  }

  
  return (
    <Box className={'section'}>
      <Typography variant="h4">
        Detailed information on the processing of Personal Data
      </Typography>
      <Typography variant="body1">
        Personal Data is collected for the following purposes and using the
        following services:
      </Typography>
      <Box className={classes.container}>

        {service.map((category, i) => (
          <Accordion
            // square
            expanded={expanded.includes(`panel${i}`)}
            onChange={handleChange(`panel${i}`)}
            key={Object.keys(category)[0]}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <InsertDriveFileOutlinedIcon />
              <Typography variant="h6">{Object.keys(category)[0]}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {category[Object.keys(category)[0]].map((service) => (
                <React.Fragment>
                  {Object.keys(service).includes('categoryDescription') && (
                    <Typography variant="body1">
                      {service.categoryDescription}
                    </Typography>
                  )}

                  <Typography variant="h6">{service.name}</Typography>
                  <Typography
                    variant="body1"
                    dangerouslySetInnerHTML={{ __html: service.description }}
                  ></Typography>
                  <Typography variant="body1">
                    Personal Data processed: {' '}
                    {service.personalData.map((i) => i.name).join('; ')}
                  </Typography>
                  <Typography variant="body1">
                    Regional Data processed: {' '}
                    {service.regionalData.map((i) => i.name).join('; ')}
                  </Typography>
                </React.Fragment>
              ))}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  )
}

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '10px',
      marginBottom: theme.spacing(1),
      flexWrap: 'wrap',
      '& > div': {
        width: '48%'
      }
    },
    [theme.breakpoints.down('sm')]: {
      container: {
        '& > div': {
          width: '99%'
        }
      }
    }
  })
)

export default DettailedInformation
